import { render, staticRenderFns } from "./OnAirSummary.vue?vue&type=template&id=c9fe6048"
import script from "./OnAirSummary.vue?vue&type=script&lang=js"
export * from "./OnAirSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports